var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.blocks),function(block,index){return _c('div',{key:index},[(block.type === 'mermaid' && block.content.includes('is-centered'))?_c('center',[_c('vue-mermaid-string',{attrs:{"value":block.content}})],1):(block.type === 'mermaid')?_c('vue-mermaid-string',{attrs:{"value":block.content}}):_c('vue-markdown-render',{attrs:{"source":block.content,"options":{
        typographer: true,
        html: true,
        breaks: true,
        linkify: true,
        highlight: _vm.highlight,
      }}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }